export default {

    payerContainer: {
        width: "100%",
        padding: "0px 30px 0px",
        flex: "1 1 0%"
    },

    cardsGroupContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "30px",
        margin: "40px 0px",
    },

    cardContainer: {
        cursor: "pointer",
    },

    individualCardStyle: {
        height: "315px",
        width: "230px",
    },

    formContainer: {
        marginTop: "40px",
        display: "flex",
        flexDirection: "column",
        rowGap: "60px",
        width: "100%",
    },

    footerText: {
        fontWeight: "700",
        fontSize: "16px",
        color: "#215DAA"
    },

    addPayerSuccessContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%"
    },

    cardHeading: {
        marginTop: "20px",
        width: "57%",
        textAlign: "center",
    },

    cardSubHeading: {
        marginTop: "10px",
        fontWeight: "normal",
        width: "57%",
        textAlign: "center",
    },

    grayBorder: {
        borderBottom: "0.5px solid #959AAA",
        width: "80%",
        margin: "20px 0px"
    },

    payerName: {
        fontWeight: "500",
        fontSize: "20px",
        color: "#252323",
    },

    questionText: {
        fontSize: "20px",
        color: "#252323",
        marginTop: "50px"
    },

    buttonsContainer: {
        display: "flex",
        columnGap: "20px",
    },

    button: {
        padding: "8px 20px"
    },

    popupStyles: {
        borderRadius: "0px",
        maxWidth: "unset",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    ConfirmRedirectionPopUpStyle:{
        maxHeight: "unset",
        height: "100%",
        overflowY: "auto",
        display: "flex",
        justifyContent:"center",
        alignItems:"center"
    },
    popupoOverlay: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 9,
    },

    popupChildrenStyles: {
        maxHeight: "unset",
        height: "100%",
        overflowY: "auto",
        display: "flex",
    },
    anchorText:{
        color: '#215DAA', 
		fontSize: '16px',
		fontWeight: 700,
        cursor:'pointer'
    }
}